// extracted by mini-css-extract-plugin
export default {"modal":"X8Qeo","linksList":"UKflO","link":"VKfUv"};